import React from "react";
import { ChatRuntimeProvider } from "./ChatRuntimeProvider";
import { KnowledgeBaseChatSidebar } from "./KnowledgeBaseChatSidebar";
import { AiChatType } from "@src/types.generated";

export const KnowledgeBaseChat: React.FC = () => {
  return (
    <ChatRuntimeProvider chatType={AiChatType.KnowledgeBase}>
      <KnowledgeBaseChatSidebar />
    </ChatRuntimeProvider>
  );
};

export default KnowledgeBaseChat;
